"use strict";

exports.__esModule = true;
exports.MeasurementValue = void 0;
exports.resolveLabelHeight = resolveLabelHeight;
var _react = _interopRequireDefault(require("react"));
var _UnitValue = require("../UnitValue");
var _TextValue = require("../TextValue/TextValue");
var _approximateFontSize = require("../approximateFontSize");
var _calculateXY2 = require("../calculateXY");
var _constants = require("../../constants");
var _excluded = ["label", "labelSize", "width", "height", "units", "textAnchor", "value", "fontSize", "color", "backgroundColor", "hideMtcAgentUnits", "centerVertically", "dataTestId"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Resolve vertical space reserved for the label when labelSize is provided.
 * @param {number} height widget height
 * @param {number} labelSize fraction of height (e.g. 0.2 = 20%)
 */
function resolveLabelHeight(height, labelSize) {
  return Math.min(height * 0.5, Math.max(12, height * labelSize));
}

/**
 * Displays a measurement value.
 */
var MeasurementValue = exports.MeasurementValue = function MeasurementValue(props) {
  var label = props.label,
    labelSize = props.labelSize,
    width = props.width,
    height = props.height,
    units = props.units,
    _props$textAnchor = props.textAnchor,
    textAnchor = _props$textAnchor === void 0 ? _constants.TEXT_ANCHOR_MIDDLE : _props$textAnchor,
    value = props.value,
    fontSize = props.fontSize,
    color = props.color,
    backgroundColor = props.backgroundColor,
    hideMtcAgentUnits = props.hideMtcAgentUnits,
    centerVertically = props.centerVertically,
    _props$dataTestId = props.dataTestId,
    dataTestId = _props$dataTestId === void 0 ? "MeasurementValue" : _props$dataTestId,
    extra = _objectWithoutPropertiesLoose(props, _excluded);
  var labelFontSize = 0;
  var labelHeight = 0;
  var labelToShow = undefined;
  if (typeof label === "string" && label.length > 0) {
    // Default label band matches historical MeasurementValue sizing.
    // labelSize is an optional override (e.g. MachineStateCount).
    labelHeight = labelSize != null && labelSize > 0 ? resolveLabelHeight(height, labelSize) : Math.min(40, Math.max(14, height / 8));
    labelFontSize = (0, _approximateFontSize.approximateFontSize)({
      width: width,
      height: labelHeight,
      value: label
    });
    labelToShow = label;
  }
  var _calculateXY = (0, _calculateXY2.calculateXY)({
      width: width,
      height: height,
      textAnchor: textAnchor
    }),
    x = _calculateXY.x;
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    width: width,
    height: height
  }, extra, {
    "data-testid": dataTestId
  }), backgroundColor && /*#__PURE__*/_react["default"].createElement("rect", {
    x: 0,
    y: 0,
    width: width,
    height: height,
    fill: backgroundColor
  }), !units ? /*#__PURE__*/_react["default"].createElement(_TextValue.TextValue, {
    width: width,
    height: height - labelHeight,
    value: value == null ? "" : String(value),
    textAnchor: textAnchor,
    fontSize: fontSize,
    fill: color || "currentColor",
    color: color,
    centerVertically: centerVertically
  }) : /*#__PURE__*/_react["default"].createElement(_UnitValue.UnitValue, {
    width: width,
    height: height - labelHeight,
    value: value,
    units: units,
    textAnchor: textAnchor,
    fontSize: fontSize,
    fill: color || "currentColor",
    color: color,
    hideMtcAgentUnits: hideMtcAgentUnits
  }), labelToShow && /*#__PURE__*/_react["default"].createElement("text", {
    x: x,
    y: height - labelHeight,
    fontSize: labelFontSize,
    fill: color || "currentColor",
    textAnchor: textAnchor,
    alignmentBaseline: "hanging",
    color: color
  }, labelToShow));
};